import { FLAGS } from '@gozoki/feature-flags'
import { createFileRoute, Navigate } from '@tanstack/react-router'
import { MapComparePage } from '~/components/routes/development/map-compare/map-compare-page'
import { useFeatureFlag, useFeatureFlagsReady } from '~/hooks/useFeatureFlag'

export const Route = createFileRoute('/_authenticated/development/map-compare')({
  component: MapCompareRoute,
})

/** Page de démo accessible uniquement par URL, derrière le flag Flipt `map-tiles-compare`. */
function MapCompareRoute() {
  const featureEnabled = useFeatureFlag(FLAGS.mapTilesCompare)
  const flagsReady = useFeatureFlagsReady()

  if (!flagsReady) {
    return <p className="p-4 text-sm text-muted-foreground">Chargement…</p>
  }

  if (!featureEnabled) {
    return <Navigate to="/" replace />
  }

  return <MapComparePage />
}
